import { Printer } from '../masterdata/models/printer';
import { LabMDM } from '../masterdata/models/lab';

export class PrintRequest {
    lab : LabMDM;
    barCode : string[];
    numberOfCopies: number;
    templateString: string;
    printer: Printer;
    asbFlag: boolean = true
}
